import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import Flexbox from 'flexbox-react';
import MessageBox from 'components/core/MessageBox';

/**
 * A simple form that lets you prompt for the name of a new entity.  The name can be either a single input
 * or a select combo box.
 */
export default class DeprecateProcessForm extends React.Component {
    static propTypes = {
        value: PropTypes.any,
    };

    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    onInputChange = (e) => {
        this.setState({ value: e.target.value });
    };

    setInvalid = (errorMessage) => {
        this.setState({ invalid: true, errorMessage });
    };

    getValue = () => {
        return this.state.value;
    }

    render() {
        const newItemNameRefFunction = (component) => {this.newItemNameComponent = component;};
        const errorMessageRefFunction = (component) => {this.errorMessageComponent = component;};
        const className = this.state.invalid ? 'invalid' : '';

        let value = this.state.value;

        return (
            <Flexbox flexDirection="column" className="new-entity-form">
                <MessageBox
                    includeIcon
                >
                    <div>
                        <p>
                            Before marking a vap/ingest as deprecated, please uninstall the process and if applicable, 
                            conf package using the the ‘obsoletes’ yaml file parameter 
                            (see <a href="https://code.arm.gov/distrib/release/-/blob/master/docs/required_files.md">https://code.arm.gov/distrib/release/-/blob/master/docs/required_files.md</a>)
                        </p>
                        <p>
                            Once a process has been set as deprecated, it will no longer be able to be edited in the PCM application.
                        </p>
                    </div>
                </MessageBox>
                <Flexbox alignItems="baseline" flexDirection="column" className={css`padding: 25px 10px 0 10px`}>
                    <label htmlFor="deprecated_text">Reason for deprecation:</label>
                    <input
                        type="text" 
                        id="deprecated_text" 
                        name="deprecated_text" 
                        className={className}
                        style={ { width: '100%'} }
                        ref={newItemNameRefFunction}
                        onChange={this.onInputChange}
                        value={value}
                        autoFocus
                    />
                </Flexbox>
                <div className={className} style={ { marginTop: '15px' } } ref={errorMessageRefFunction}>
                    {this.state.errorMessage}
                </div>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/forms/DeprecateProcessForm.js